import React, { useContext, useEffect } from "react";
import ReactFacebookPixel from "@bettercart/react-facebook-pixel";
import { useFacebookPixels } from "../../hooks/useFacebookPixels";
import { useTrackingPixels } from "../../hooks/useTrackingPixels";
import { CheckoutContext } from "../../contexts/CheckoutContext";

const FacebookPixels: React.FC = () => {
  const trackingPixels = useTrackingPixels();
  const { offer } = useContext(CheckoutContext);

  const { onCheckoutVisit } = useFacebookPixels(offer?.pixelEventId);

  useEffect(() => {
    trackingPixels.facebook_pixels.forEach((pixel) => {
      ReactFacebookPixel.init(pixel.pixelId);
    });
    if (offer) {
      onCheckoutVisit(offer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingPixels]);

  return null;
};

export default FacebookPixels;
